import {DefaultAdaptiveInput, PlayableAdaptiveResponse, PlayerReduxDispatch, PlayerReduxState} from "../types";
import {AdaptiveInput, ChallengeMode, EducationSessionErrorReason} from "../../../schema";
import {ResponseTimeoutState} from "../../../types/ResponseTimeoutState";

export default function syncAdaptiveInput(newAdaptiveInput?: AdaptiveInput) {
  return (dispatch: PlayerReduxDispatch, getState: () => PlayerReduxState) => {
    if (!newAdaptiveInput) return;

    const responses = newAdaptiveInput.responses ?? [];

    const state = getState();

    if (state.responseTimeoutState === ResponseTimeoutState.FINISHED) {
      return;
    }
    const currentAdaptiveResponses = state.adaptiveInput?.responses ?? [];

    const currentAdaptiveResponseIds = currentAdaptiveResponses.map(({id}) => id) ?? [];

    let newResponses: PlayableAdaptiveResponse[] = [];

    responses.forEach((response) => {
      if (!currentAdaptiveResponseIds.includes(response.id)) {
        newResponses.push({
          ...response,
          played: false,
        });
      }
    });

    newResponses = currentAdaptiveResponses.concat(newResponses).sort((a, b) => a.index - b.index);

    const notAllPlayedYet = newResponses.some((response) => !response.played);
    const isError = !!newAdaptiveInput.isError;
    const isRpgMode = state.challenge.mode === ChallengeMode.RPG_MODE;
    const doStopResponseTimeout =
      state.responseTimeoutState === ResponseTimeoutState.STARTED && (newResponses.length > 0 || isError);

    dispatch({
      type: "update",
      payload: {
        isRecognizing: isError ? false : (!newAdaptiveInput.isClosed && newResponses.length === 0) || notAllPlayedYet,
        adaptiveInput: isError
          ? null
          : {
              ...DefaultAdaptiveInput,
              ...{
                ...(state.adaptiveInput || {}),
              },
              id: newAdaptiveInput.id,
              uuid: newAdaptiveInput.uuid,
              isClosed: newAdaptiveInput.isClosed,
              responses: newResponses,
            },
        lastUserInputResult: {
          ...(state.lastUserInputResult ?? {}),
          ok: isError ? false : (state.lastUserInputResult?.ok ?? true),
          errorState: isError
            ? EducationSessionErrorReason.VIEWA_SERVICE_ERROR
            : (state.lastUserInputResult?.errorState ?? null),
        },
        responseTimeoutState: doStopResponseTimeout ? ResponseTimeoutState.ABORTING : state.responseTimeoutState,
        ...(isError && isRpgMode ? {rpgTurnKey: state.rpgTurnKey + 1} : {}),
      },
    });

    if (newResponses && newResponses.length > 0 && !state.adaptiveInput?.startedPlaying)
      dispatch({type: "playAdaptiveResponse"});
  };
}
